var _g, _circle, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConsumerBoxing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2516_56331)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.09153 3.6338C3.4289 5.37745 1.73018 8.4878 3.99581 10.6787C4.238 10.9116 4.46553 11.1416 4.68528 11.3677L6.00022 12.6826C6.135 12.8174 6.238 13.1582 6.05297 13.3169C5.83959 13.4995 5.50559 13.3677 5.37084 13.2329L4.9065 12.7681C4.58862 13.3203 4.51831 13.9912 4.88747 14.7744C5.58668 16.2593 7.91725 16.9761 9.50415 16.5576C9.86012 16.4624 10.7854 16.2515 11.5257 16.4629L13.5589 18.4888C13.9715 18.9009 14.6399 18.9009 15.052 18.4883L18.6907 14.8496C19.1028 14.4375 19.1028 13.7685 18.6907 13.3574L16.2097 10.876C16.2581 10.3789 16.2005 9.8418 16.012 9.26123C14.4733 4.52051 11.9943 2.17336 8.09153 3.6338ZM17.1047 13.6367L13.9323 16.8091L12.8122 15.6895L15.9851 12.5171L17.1047 13.6367Z",
    fill: "#C11313"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11.0005,
    r: 10.75,
    stroke: "#C11313",
    strokeWidth: 0.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2516_56331"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(3 3.00049)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConsumerBoxing);
export default __webpack_public_path__ + "static/media/consumer_boxing.f7e127b3af54c7de9d99c29f88f84089.svg";
export { ForwardRef as ReactComponent };